import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'HEALTH_PROFESSIONAL';

const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
  const result = data.filter(item => {
    const professionalName = item.name ? filterByTerm(item.name, term) : false;
    const address = item.address.address ? filterByTerm(item.address.address, term) : false;
    // const professionClientName = item.client.name ? filterByTerm(item.client.name, term) : false;
    return (
      professionalName || address
      // professionClientName
    );
  });

  result.sort(sort);

  return result;
};

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;
      const loadedData = [...currentData, ...newData];
      return {
        ...state,
        loading: false,
        loadedData,
        filter: {
          ...state.filter,
          data: loadedData
        }
      };
    }
    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;
      const loadedData = [...currentData, ...newData];
      return {
        ...state,
        loading: false,
        loadedData,
        filter: {
          ...state.filter,
          data: loadedData
        }
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { data, searchTerm } = action.payload;
      return {
        ...state,
        loading: false,
        // loadedData: data,
        filter: {
          ...state.filter,
          data: searchTerm ? data : state.loadedData
        }
      };
    }
    case `${TEMPLATE_NAME}_CREATE`: {
      const newRow = action.payload;
      const loadedData = [...state.loadedData, newRow];
      return {
        ...state,
        loading: false,
        loadedData,
        filter: {
          ...state.filter,
          data: filterData(loadedData, state.filter.term, state.filter.type)
        }
      };
    }
    case `${TEMPLATE_NAME}_UPDATE`: {
      const updatedRow = action.payload;
      const loadedData = state.loadedData.map(row => (row.id === updatedRow.id ? updatedRow : row));

      return {
        ...state,
        loadedData,
        filter: {
          ...state.filter,
          data: [...loadedData]
        }
      };
    }
    case `${TEMPLATE_NAME}_DELETE`: {
      const deletedId = action.payload;
      const data = state.data.filter(data => data.id !== deletedId);

      return {
        ...state,
        loading: false,
        data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term, state.filter.type)
        }
      };
    }

    case `${TEMPLATE_NAME}_FILTER_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_FILTER_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FILTER_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: [...state.loadedData, ...newData]
        }
      };
    }
    case `${TEMPLATE_NAME}_SIGNATURE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_SIGNATURE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_SIGNATURE_FULFILLED`: {
      const professionalId = action.payload.id;

      const updateData = data => {
        if (data.id === professionalId) {
          data.signature = action.payload.signature;
        }
        return data;
      };

      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          data: state.filter.data.map(updateData)
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
